import { Payment } from '@payment/const';
import { StateUtils } from '@spartacus/core';

export const PAYMENT_FEATURE = 'payment';
export const PAYMENT_LIST = '[Payment] Payment list';
export const PAYMENT_DELETE_PAYMENT = '[Payment] Delete payment';
export const PAYMENT_BIND_PAYMENT = '[Payment] Bind payment';

export interface StateWithPayment {
  [PAYMENT_FEATURE]: PaymentState;
}

export interface PaymentState {
  paymentList: StateUtils.LoaderState<Payment[]>;
  deletePayment: StateUtils.LoaderState<void>;
  bindPayment: StateUtils.LoaderState<string | null>;
  bindPaymentLater?: boolean;
}
